/* tslint:disable */

declare var Object: any;
export interface TotemInterface {
  "idsucursal"?: number;
  "idtotem": number;
  "inventario"?: string;
  "modelo"?: string;
}

export class Totem implements TotemInterface {
  "idsucursal": number;
  "idtotem": number;
  "inventario": string;
  "modelo": string;
  constructor(data?: TotemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Totem`.
   */
  public static getModelName() {
    return "Totem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Totem for dynamic purposes.
  **/
  public static factory(data: TotemInterface): Totem{
    return new Totem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Totem',
      plural: 'Totems',
      path: 'Totems',
      idName: 'idtotem',
      properties: {
        "idsucursal": {
          name: 'idsucursal',
          type: 'number'
        },
        "idtotem": {
          name: 'idtotem',
          type: 'number'
        },
        "inventario": {
          name: 'inventario',
          type: 'string'
        },
        "modelo": {
          name: 'modelo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Totem.ts